const fixedBankAccounts = [
  {
    id: 1,
    bank_code: '061',
    bank_name: 'ANZ Indonesia',
    bank_account: '111111111112',
    biller_code: '1234123412345',
    preferred_channel: 'GENESIS',
    backup_channel: 'ARTAJASA',
  },
  {
    id: 2,
    bank_code: '116',
    bank_name: 'Bank Aceh',
    bank_account: '222222111112',
    biller_code: '1234123412345',
    preferred_channel: 'ARTAJASA',
    backup_channel: 'ALTO',
  },
  {
    id: 3,
    bank_code: '945',
    bank_name: 'Bank Agris',
    bank_account: '333333111112',
    biller_code: '1234123412345',
    preferred_channel: 'DCBNI',
    backup_channel: 'DCCIMB',
  },
  {
    id: 4,
    bank_code: '088',
    bank_name: 'Bank Antardaerah',
    bank_account: '444444111112',
    biller_code: '1234123412345',
    preferred_channel: 'DCCIMB',
    backup_channel: 'ALTO',
  },
  {
    id: 5,
    bank_code: '037',
    bank_name: 'Bank ARTHA GRAHA',
    bank_account: '555555111112',
    biller_code: '1234123412345',
    preferred_channel: 'DCBNI',
    backup_channel: 'ALTO',
  },
  {
    id: 6,
    bank_code: '542',
    bank_name: 'Bank ARTOS',
    bank_account: '666666111112',
    biller_code: '1234123412345',
    preferred_channel: 'ALTO',
    backup_channel: 'DCCIMB',
  },
];

export { fixedBankAccounts };
